//Master Data
const masterTableFields = [
    {title: "Ref Id",
        class_name: 'w-110p',
        fetch_key: "id"
    },
    // {title: "File",
    //     fetch_key: "file"
    // },
    {title: "IFSPD Program",
        fetch_key: "program_name"
    },
    {title: "Title",
        fetch_key: "title"
    },
    {title: "Introduction",
        fetch_key: "introduction"
    },
    {title: "Description",
        fetch_key: "description"
    },
    {title: "Level/Year",
        fetch_key: "level_name"
    },
    {title: "Council",
        fetch_key: "session_id"
    },
    {title: "File Type",
        fetch_key: "file_type"
    },
    {title: "Status",
        fetch_key: "active_status_id"
    },
    {title: "Uploaded Date",
      class_name: 'w-125p',
      fetch_key: "created_at",
      accessRoleIds: [2, 7]
    }
];
//Fields to Activate/Deactivate Resources
const fieldUpdateStatus = [
    {colMd: "3", label: "Status", required: true, type: "select", name: "active_status_id", placeholderData: ["Select Status"]},
    {colMd: "9", label: "Ref Ids", required: true, type: "text", name: "ref_ids", placeholderData: ["Ids Separated by comma, Ex: 123,456,789"], readonly: true},
];
const fieldUpdateActiveValues = {
    ref_ids: '',
    ref_ids_array: [],
    active_status_id: ''
};
const fieldValidationStatus = {
    active_status_id: 'required||Status',
    ref_ids: 'required||Ref Ids'
};
//New Resource
const newResDefaultValues = {
    file_size: 0,
    files: [],
    program_id: '',
    level_id: '',
    session_id: ''
};
// Filter
const filterTableData = [
    {colMd: "3", label: "IFSPD Program", type: "multi-select", name: "program_id"},
    {colMd: "3", label: "Level/Year", type: "multi-select", name: "level_id"},
    {colMd: "3", label: "Council", type: "multi-select", name: "session_id"},
    {colMd: "3", label: "File Type", type: "multi-select", name: "file_type"},
    {colMd: "3", label: "Status", type: "select", name: "active_status_id", accessRoleIds: [2, 7]},
    {colMd: "9", label: "Title", type: "text", name: "title"},
];
//Update Resource
const fieldResourceEdit = [
  {colMd: "12", label: "Title", required: true, type: "textarea", name: "title", count: 200, rows: 1},
  {colMd: "12", label: "Introduction", required: false, type: "ckeditor", name: "introduction", count: 1000, rows: 5},
  {colMd: "12", label: "Description", required: false, type: "ckeditor", name: "description", count: 1000, rows: 5},
];

const fieldValidationResEdit = {
    id: 'required',
    title: 'required|max:200',
    introduction: 'optional|max:1000',
    description: 'optional|max:1000',
};

export {
    masterTableFields,
    //To Active-Inactive Resources
    fieldUpdateActiveValues,
    fieldUpdateStatus,
    fieldValidationStatus,
    // New
    newResDefaultValues,
    //Filter
    filterTableData,
    //Edit
    fieldResourceEdit,
    fieldValidationResEdit
};